import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import axios from 'src/api/Api';
import {
    GET_OUTSIDE_SHIPPING_METHODS_FAILURE,
    GET_INSIDE_SHIPPING_METHODS_FAILURE,
    GET_OUTSIDE_SHIPPING_METHODS_SUCCESS,
    GET_INSIDE_SHIPPING_METHODS_SUCCESS,
} from '../action/types';
import { convertObjectToQueryParams } from 'src/utils/util';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getShippingMethods(action) {
    const { isOutside } = action.payload;

    const surgeryAccountId = yield select((state) =>
        isOutside
            ? state.reportShipToAddressReducer.outsideSurgeryDetails?.accountId
                  ?.accountId
            : state.reportShipToAddressReducer.insideSurgeryDetails?.accountId
                  ?.accountId
    );
    const countryCode = localStorage.getItem('countryISOCode');
    const selectedAccountDetails = yield select((state) =>
        isOutside
            ? state.reportShipToAddressReducer.outsideSurgeryDetails?.accountId
            : state.reportShipToAddressReducer.insideSurgeryDetails?.accountId
    );
    const requestedDeliveryDateMandatory = yield select(
        (state) => state.loginReducer?.requestedDeliveryDateMandatory
    );

    // const surgeryAccountId = yield select(
    //     (state) => state.surgeryReducer?.surgeryDetails?.accountId?.accountId
    // );

    // const selectedAccountDetails = yield select(
    //     (state) =>
    //         state.surgeryReducer?.surgeryDetails &&
    //         state.surgeryReducer?.surgeryDetails?.accountId
    // );
    const sapPartnerId = surgeryAccountId || selectedAccountDetails;

    const params =
        requestedDeliveryDateMandatory === 'YES'
            ? {
                  orderType: action.payload.orderType,
                  shipToAcc: action.payload.shipToAcc,
                  salesOrg: action.payload.salesOrg,
                  surgeryDate: action.payload.surgeryDate,
                  currentDate: action.payload.currentDate,
                  requestDeliveryDate: action.payload.requestDeliveryDate,
                  requestedDeliveryDateMandatoryRule:
                      action.payload.requestedDeliveryDateMandatoryRule,
                  requestedDeliveryDateVisbility:
                      action.payload.requestedDeliveryDateVisbility,
              }
            : // countryCode === COUNTRY_CODE_JAPN
              //     ?
              {
                  orderType: action.payload.orderType,
                  shipToAcc: action.payload.shipToAcc,
                  salesOrg: action.payload.salesOrg,
                  surgeryDate: action.payload.surgeryDate,
                  currentDate: action.payload.currentDate,
                  requestedDeliveryDateMandatoryRule:
                      action.payload.requestedDeliveryDateMandatoryRule,
                  requestedDeliveryDateVisbility:
                      action.payload.requestedDeliveryDateVisbility,
              };
    // : {
    //       orderType: action.payload.orderType,
    //       shipToAcc: action.payload.shipToAcc,
    //       salesOrg: action.payload.salesOrg,
    //   };

    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/surgery/shippingmethod?${convertObjectToQueryParams({
        ...params,
        sapPartnerId,
    })}`;

    try {
        const result = yield axios.get(url).then((response) => response.data);
        if (isOutside) {
            yield put({
                type: GET_OUTSIDE_SHIPPING_METHODS_SUCCESS,
                payload: {
                    data: result.shipMethods,
                    salesOrg: action.payload.salesOrg,
                    showShippingMethods: result.isValuePresent,
                },
                statusCode: result.statusCode,
                statusMessage: result.statusMessage,
            });
        } else {
            yield put({
                type: GET_INSIDE_SHIPPING_METHODS_SUCCESS,
                payload: {
                    data: result.shipMethods,
                    salesOrg: action.payload.salesOrg,
                    showShippingMethods: result.isValuePresent,
                },
                statusCode: result.statusCode,
                statusMessage: result.statusMessage,
            });
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        if (!isOutside) {
            yield put({
                type: GET_INSIDE_SHIPPING_METHODS_FAILURE,
                statusCode: errorHandler('503'),
                statusMessage: e.Error,
            });
        } else {
            yield put({
                type: GET_OUTSIDE_SHIPPING_METHODS_FAILURE,
                statusCode: errorHandler('503'),
                statusMessage: e.Error,
            });
        }
    }
}
